import first from 'lodash/first'
import values from 'lodash/values'
import { useRouter } from 'next/router'
import React, { useContext } from 'react'
import styled, { css } from 'styled-components'

import { YOLOFlagIcon } from '@Components/Icons'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'
import { UserContext } from '@Globals/User'

const YOLOWrapper = styled.aside(({ theme }) => css`
  display: flex;
  gap: ${theme.padding.mobile};
  justify-content: center;
  align-items: center;
  font-size: .8rem;
  margin: ${theme.padding.mobile} 0;
`)

export const YOLOShipping = () => {
  const { locale } = useRouter()
  const { store } = useContext(MetadataContext)
  const { t } = useTranslation()
  const { userData } = useContext(UserContext)
  if (!userData) { return null }

  const { otherCountry } = userData

  if (!otherCountry || (locale !== 'en-US' && locale !== 'es-US')) { return null }

  const country = otherCountry.countryNameMap[store?.id] || first(values(otherCountry.countryNameMap))

  return (
    <YOLOWrapper>
      <span>{t('header:WE_SHIP_TO_X', { arg1: country })}</span>
      <YOLOFlagIcon country={otherCountry.country || ''} />
    </YOLOWrapper>
  )
}
